import { createRoot, createSignal, type Signal } from "solid-js"
import { addListener, type EventListenerList } from "../../../event/event"
import { getInputProfileMetaFromLocalStorage, setInputProfileMetaToLocalStorage } from "./inputProfileLocalStorage"
import type { InputProfileMeta } from "./InputProfileMeta.type"

export const inputProfileMetaUpdatedEvent: EventListenerList<InputProfileMeta> = [
  (newValue) => {
    setInputProfileMetaToLocalStorage(newValue)
  },
]

const signal: Signal<InputProfileMeta> = createRoot(() => {
  const meta = getInputProfileMetaFromLocalStorage() || { selected: undefined }
  const [getInputProfileMeta, setInputProfileMeta] = createSignal<InputProfileMeta>(meta)
  
  // Listen for updates
  addListener(inputProfileMetaUpdatedEvent, (newValue) => {
    setInputProfileMeta(newValue)
  })
  
  return [getInputProfileMeta, setInputProfileMeta] as Signal<InputProfileMeta>
})

export const [getInputProfileMeta, setInputProfileMeta] = signal

export default function createInputProfileMetaSignal() {
  return signal
}

